var $ = require('jquery')

module.exports = function applyActionWhenClicked(action) {

  return function(selector, context) {
    var context = context || $('body')

    context.on('click', selector, function(e) {
      e.preventDefault()
      action(e)
    })
  }
}
